import { removeAutopilotEmoji } from "#webapp/src/util/event.util";
import getNextOccuranceText from "#webapp/src/util/getNextOccuranceText";
import {
  EventTable,
  EventTableHeading,
  EventTableRow,
} from "@clockwise/web-commons/src/components/EventTable/";
import { useGatewayQuery } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { Interval } from "luxon";
import React from "react";
import { useSetFlexibility } from "../flexible-meetings/useSetFlexibility";
import { MyFlexibleMeetingsDashboardDocument } from "./__generated__/MyFlexibleMeetingsDashboard.v2.generated";

const trackingSourceId = "My flexible meetings control";

export const MyFlexibleMeetings = () => {
  const { data, loading, error } = useGatewayQuery(MyFlexibleMeetingsDashboardDocument);
  const { handleFlexibilityChange } = useSetFlexibility(
    data?.flexibleMeetingsDashboard.flexibleMeetings ?? [],
    trackingSourceId,
  );

  const flexibleMeetings = (data?.flexibleMeetingsDashboard.flexibleMeetings ?? []).map(
    (meeting) => ({
      id: meeting.externalEventId,
      attendees: meeting.attendees.map((a) => a.person),
      flexible: !!meeting.flexibility?.isFlexible,
      flexibilityEditable: meeting.canMarkFlexible,
      startTime: Interval.fromISO(
        meeting.dateOrTimeRange.__typename === "DateRange"
          ? meeting.dateOrTimeRange.dateRange
          : meeting.dateOrTimeRange.timeRange,
      ).start,
      recurrenceText: meeting.timeDescription,
      title: removeAutopilotEmoji(meeting.title),
    }),
  );

  return (
    <>
      <div className="cw-mb-3 cw-border-b cw-border-default cw-border-solid">
        <EventTableHeading headingLevel="h2" heading="Other flexible meetings" />
      </div>
      <div>
        <EventTable
          emptyText="No other flexible meetings to display at this time"
          errorText={
            error
              ? "There was an error fetching your flexible meetings. Please try again."
              : undefined
          }
          loading={loading}
          onFlexibilityChange={handleFlexibilityChange}
          showAvatars
        >
          {flexibleMeetings.map(
            ({
              attendees,
              id,
              title,
              startTime,
              recurrenceText,
              flexible,
              flexibilityEditable,
            }) => (
              <EventTableRow
                editable={flexibilityEditable}
                attendees={attendees}
                eventId={id}
                flexible={flexible}
                key={id}
                nextOccruance={startTime ? getNextOccuranceText(startTime) : "Unknown Date"}
                recurrence={recurrenceText}
                title={title}
              />
            ),
          )}
        </EventTable>
      </div>
    </>
  );
};
